module.exports = "<div class=\"bws-product-image-lazy-transition-wrapper\">\r\n    <img\r\n        class=\"{{ ::vm.imgClass }}\"\r\n        ng-src=\"{{ vm.imgSrc }}\"\r\n        loading=\"lazy\"\r\n        alt=\"{{ vm.imgAlt }}\" />\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/common/components/images/bws-image-template.html
 ** module id = 852
 ** module chunks = 2
 **/